<style scoped>
.item-title {
  padding: 24px;
}
.attachment-content {
  padding: 10px;
}
.radio-button {
  padding-left: 4px;
  padding-right: 4px;
}
.size-input {
  padding-left: 16px;
}
.mu-input {
  min-height: 1px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  width: auto;
}
.enrollment-button {
  margin: 8px 4px 8px 4px;
}
.enrollment-button-panel {
  margin-right: 4px;
}
.mu-flat-button {
  min-width: 0px;
}
.empty-message-wrapper {
  text-align: center;
  padding: 24px;
  width: 100%;
}
.csv-hint-wrapper {
  padding: 4px;
}
</style>

<template>
  <div>
    <mu-button small icon @click="onClickBack"><mu-icon value="keyboard_backspace" /></mu-button>
    <input type="file" id="file" ref="file" @change="handleFiles" accept=".csv" class="display-none"/>
    <mu-container>
      <mu-paper :z-depth="1">
        <div>
          <span class="float-right" >
            <mu-button icon @click="onClickAttachment" v-tooltip="$t('enrollment.attachment')">
              <mu-icon value="attachment"></mu-icon>
            </mu-button>
            <mu-text-field v-model="modelSearchBar" icon="search"></mu-text-field>
          </span>
          <h1 class="item-title">{{$t('enrollment.enroll')}}</h1>
        </div>
        <div v-if="csv.length === 0 && modelSearchBar.length === 0" class="empty-message-wrapper">{{$t('enrollment.emptyMessage')}}</div>
        <mu-data-table :columns="enrollColumns" stripe :data="listSearchBar" :no-data-text="$t('empty.noDataTitle')" v-if="modelSearchBar.length">
          <template slot-scope="scope">
          <td>{{scope.row.name}} ({{scope.row.username}})</td>
          <td>{{scope.row.email}}</td>
          <td>
            <mu-button small flat @click="onClickEnroll(scope.row._id)" color="primary" v-if="!isEnrolled(scope.row)">
              <mu-icon value="add" size="20" class="vertical-align-bottom"></mu-icon> {{$t('enrollment.enroll')}}
            </mu-button>
            <mu-button small flat v-else disabled>
              <mu-icon value="check" size="20" class="vertical-align-bottom"></mu-icon> {{$t('enrollment.enrolled')}}
            </mu-button>
          </td>
          </template>
        </mu-data-table>
        <div v-if="csv.length">
          <div class="attachment-content">
            <h3>{{$t('enrollment.attachment')}}</h3>
            <div class="float-right">
              <mu-radio value="cas" v-model="modelAttachmentType" :label="$t('profile.type.cas')" class="radio-button"></mu-radio>
              <mu-radio value="guest" v-model="modelAttachmentType" :label="$t('profile.type.guest')" class="radio-button"></mu-radio>
            </div>
            <div>
              <mu-checkbox v-model="modelHeader" :label="$t('enrollment.csv.header')"></mu-checkbox>
            </div>
            <div v-if="modelAttachmentType === 'guest'">
              <mu-checkbox v-model="modelGeneratePassword" :label="$t('enrollment.csv.password')" class="vertical-align-middle"></mu-checkbox>
              <mu-text-field class="radio-button" v-model="modelPasswordSize" type="number"></mu-text-field>
              <div v-if="modelGeneratePassword">
                <mu-checkbox v-model="modelExcludeSimilar" :label="$t('enrollment.csv.exclude')"></mu-checkbox>
                <br />
                <mu-radio class="size-input" v-model="modelPasswordType" v-for="option in passwordTypeOptions" :key="option.value" :label="option.text" :value="option.value"></mu-radio>
              </div>
            </div>
          </div>
          <b class="csv-hint-wrapper">{{$t('enrollment.csv.format.' + modelAttachmentType)}}</b>
          <mu-data-table :columns="computedCsvColumns" border :data="computedData">
            <template slot="th" slot-scope="column">
            <div v-if="modelHeader"><b>{{csv[0][column.name]}}</b></div>
            <mu-select v-model="modelColumns[column.name]" v-if="modelColumns[column.name] !== 'generatedPassword'">
              <mu-option v-for="option in columnOptions" :key="option.value" :label="option.text" :value="option.value"></mu-option>
            </mu-select>
            <div v-else>{{$t('enrollment.csv.generatedPassword')}}</div>
            </template>
          </mu-data-table>
          <div class="float-right enrollment-button-panel">
            <mu-button color="primary" @click.prevent="onActionAttachment" class="enrollment-button"><mu-icon value="check"></mu-icon> {{$t('enrollment.enroll')}}</mu-button>
            <mu-button color="secondary" @click.prevent="onClickResetAttachment" class="enrollment-button"><mu-icon value="close"></mu-icon> {{$t('prompt.cancel')}}</mu-button>
            <mu-button color="primary" @click.prevent="onClickExport" class="enrollment-button"><mu-icon value="get_app"></mu-icon> {{$t('button.export')}}</mu-button>
          </div>
          <div class="clearfix" />
        </div>
      </mu-paper>
      <br/>
      <mu-paper :z-depth="1" v-if="flagFetchedEnrollment">
        <div class="display-flex">
          <h1 class="item-title">{{$t('enrollment.drop')}}</h1>
          <span class="flex-item" />
          <mu-button flat color="primary" @click.prevent="onClickExportStudentList" class="enrollment-button"><mu-icon value="get_app"></mu-icon> {{$t('button.export')}}</mu-button>
          <mu-text-field v-model="modelSearchDrop" icon="search"></mu-text-field>
        </div>
        <mu-data-table :columns="dropColumns" stripe :data="searched.slice((currentPage - 1) * itemsPerPage, (currentPage - 1) * itemsPerPage + itemsPerPage)" :no-data-text="$t('empty.noDataTitle')">
          <template slot-scope="scope">
          <td>{{scope.row.user.name}} ({{scope.row.user.username}})</td>
          <td>{{stringUser(scope.row,"email")}}</td>
          <td>{{scope.row.created_at}}</td>
          <td>{{stringLastActiveAt(scope.row.user)}}</td>
          <td>
            <mu-button small flat @click="onClickDrop(scope.row.user._id)" color="secondary">
              <mu-icon value="remove" size="20" class="vertical-align-bottom"></mu-icon> {{$t('enrollment.drop')}}
            </mu-button>
          </td>
          </template>
        </mu-data-table>
        <mu-flex justify-content="center">
          <mu-pagination :total="searchedTotal" :current.sync="currentPage" :page-size="itemsPerPage"></mu-pagination>
        </mu-flex>
      </mu-paper>
    </mu-container>
  </div>
</template>

<script>

// Library
import axios from "axios";
import mime from 'mime-types'

// Utils
import generatePassword from '@/utils/generatePassword.js'
import lastTimeAt from '@/utils/lastTimeAt.js'

export default {
  name: 'EnrollmentPage',
  props: {
    channelId: {
      type: String,
      required: true
    }
  },
  data() {
    return {

      loading: null,

      // Object
      enrollments: [],

      // Model
      modelAttachmentType: "cas",
      modelHeader: true,
      modelSearchBar: "",
      modelSearchDrop: "",
      modelColumns: ["username", "email", "fullname"],
      modelGeneratePassword: false,
      modelPasswordSize: 12,
      modelPasswordType: 'a-z,A-Z,0-9,#',
      modelExcludeSimilar: true,

      // Flag
      flagFetchedEnrollment: false,
      flagAdmin: false,

      // Table
      currentSort: 'status',
      currentSortOrder: 'asc',

      // Object
      listSearchBar: [],

      currentPage: 1,
      itemsPerPage: 10,

      timeout: null,
      
      csv: [],
    }
  },
  computed: {
    // Flag
    isAdmin() {
      return this.$store.getters.isAdmin || this.flagAdmin;
    },

    // Store
    triggerRefresh() {
      return this.$store.getters.triggerRefresh;
    },

    enrollColumns() {
      var array = [
        { title: this.$t('profile.username'), name: 'username' },
        { title: this.$t('profile.email'), name: 'email' },
        { title: this.$t('button.manage'), name: 'manage' },
      ];
      return array;
    },

    dropColumns() {
      var array = [
        { title: this.$t('profile.username'), name: 'username' },
        { title: this.$t('profile.email'), name: 'email' },
        { title: this.$t('enrollment.time'), name: 'created_at' },
        { title: this.$t('profile.last_active_at'), name: 'last_active_at' },
        { title: this.$t('button.manage'), name: 'manage' },
      ];
      return array;
    },
    csvColumns() {
      var array = [];
      if(this.csv.length > 0) {
        this.csv[0].forEach((item, index) => {
          array.push({title: "", name: index});
        });
      }
      return array;
    },
    computedCsvColumns() {
      if(this.modelAttachmentType === 'guest' && this.modelGeneratePassword) {
        return this.csvColumns.concat({title: "", name: this.csvColumns.length});
      } else {
        return this.csvColumns;
      }
    },
    computedData() {
      if(this.modelAttachmentType === 'guest' && this.modelGeneratePassword) {
        return this.computedCsv.map((item, index) => {
          return item.concat(this.computedPassword[index]);
        });
      } else {
        return this.computedCsv;
      }
    },
    
    columnOptions() {
      var arr = [
        { value: '', text: "N/A" },
        { value: 'username', text: this.$t('profile.username') },
        { value: 'email', text: this.$t('profile.email') },
        { value: 'fullname', text: this.$t('profile.fullname') },
      ];
      if(this.modelAttachmentType === 'guest' && !this.modelGeneratePassword) {
        arr.push({ value: 'password', text: this.$t('profile.password.display') });
      }
      return arr;
    },
    passwordTypeOptions() {
      var arr = [
        { value: 'a-z,A-Z,0-9,#', text: this.$t('enrollment.csv.passwordType.all') },
        { value: 'a-z,A-Z', text: this.$t('enrollment.csv.passwordType.alphabet') },
        { value: 'A-Z', text: this.$t('enrollment.csv.passwordType.uppercase') },
        { value: 'a-z', text: this.$t('enrollment.csv.passwordType.lowercase') },
        { value: '0-9', text: this.$t('enrollment.csv.passwordType.number') },
      ];
      return arr;
    },
    computedPasswordChar() {
      if(this.modelExcludeSimilar) {
      if(this.modelPasswordType === 'all') {
        return 'a-h,j-k,m-n,p-z,A-K,M-N,P-Z,2-9,#';
      } else if(this.modelPasswordType === 'alphabet') {
        return 'a-h,j-k,m-n,p-z,A-K,M-N,P-Z';
      } else if(this.modelPasswordType === 'uppercase') {
        return 'A-K,M-N,P-Z';
      } else if(this.modelPasswordType === 'lowercase') {
        return 'a-h,j-k,m-n,p-z';
      } else if(this.modelPasswordType === 'number') {
        return '2-9';
      }
      } else {
      if(this.modelPasswordType === 'all') {
        return 'a-z,A-Z,0-9,#';
      } else if(this.modelPasswordType === 'alphabet') {
        return 'a-z,A-Z';
      } else if(this.modelPasswordType === 'uppercase') {
        return 'A-Z';
      } else if(this.modelPasswordType === 'lowercase') {
        return 'a-z';
      } else if(this.modelPasswordType === 'number') {
        return '0-9';
      }
      }
    },
    
    searched() {
      if(this.modelSearchDrop.length > 0) {
        return this.searchBy(this.enrollments, this.modelSearchDrop);
      } else {
        return this.enrollments;
      }
    },
    searchedTotal() {
      return this.searched.length;
    },
    
    computedPassword() {
      var result = [];
      var i;
      for (i = 0; i < this.computedCsv.length; i++) { 
      result.push(generatePassword(this.computedPasswordChar, parseInt(this.modelPasswordSize)));
      }
      return result;
    },
    
    computedCsv() {
      var result = [];
      if(this.modelHeader) {
      result = this.csv.filter((item, index) => {
        if(index == 0) {
        return false;
        } else {
        return true;
        }
      });
      } else {
      result = this.csv;
      }
      result = result.filter(item => {
      var empty = true;
      item.forEach(val => {
        if(val !== '' && val !== null && typeof val !== 'undefined') {
        empty = false;
        }
      });
      return !empty;
      });
      return result;
    },
  },
  watch: {
    triggerRefresh() {
      this.fetchEnrollments();
    },
    modelSearchBar(newValue) {
      if(newValue !== "") {
        this.fetchSearch(newValue);
      } else {
        this.listSearchBar = [];
      }
    },
    modelGeneratePassword(newValue) {
      if(newValue && this.modelAttachmentType === 'guest') {
        this.modelColumns[this.csv[0].length] = 'generatedPassword';
      } else {
        if(this.modelColumns.indexOf('generatedPassword') !== false)
          this.modelColumns.splice(this.modelColumns.indexOf('generatedPassword'), 1);
      }
    },
    modelAttachmentType(newValue) {
      if(newValue === 'cas') {
        this.modelGeneratePassword = false;
        if(this.modelColumns.indexOf('generatedPassword') !== false)
          this.modelColumns.splice(this.modelColumns.indexOf('generatedPassword'), 1);
      }
    }
  },
  created() {
    this.checkPermit();
  },
  methods: {
    // Fetch
    checkPermit() {
      axios.get(this.$store.getters.urlApi + "permit/channel/" + this.channelId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        var result = response.data.data.admin;
        if(result) {
          this.fetchAdmin();
        } else {

          this.$router.push({
            name: 'Home'
          });
        }
      });
    },
    fetchAdmin() {
      axios.get(this.$store.getters.urlApi + "admin/channel/" + this.channelId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.flagAdmin = response.data.data.admin.user_ids.includes(this.$store.state.auth.user._id);
        if(this.isAdmin) {
          this.fetchEnrollments();
        } else {
          this.$store.commit("toRoute", {
            path: "/channel/" + this.channelId,
          });
        }
      });
    },
    fetchEnrollments() {
      axios.get(this.$store.getters.urlApi + "enrollment/channel/" + this.channelId, {
        headers: {
          token: this.$store.state.auth.token
        }
        }
      ).then(response => {
        this.enrollments = response.data.data.enrollments;
        this.flagFetchedEnrollment = true;

      });
    },
    fetchSearch(searchTerm) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        if (!searchTerm) {
          this.listSearchBar = [];
        } else {
          axios.get(this.$store.getters.urlApi + "search/user?query=" + searchTerm + '&filter=enrollment&channel=' + this.channelId, {
            headers: {
              token: this.$store.state.auth.token
            }
            }
          ).then(response => {
            this.listSearchBar = response.data.data.results;
          });
        }
      }, 300);
    },

    // Event
    onClickEnroll(user_id) {
      axios.post(this.$store.getters.urlApi + "enrollment/channel/" + this.channelId, {
        'user_id': user_id
        }, {
        headers: {
          token: this.$store.state.auth.token,
          'content-type': 'application/json'
        },
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onClickDrop(user_id) {
      axios.delete(this.$store.getters.urlApi + "enrollment/channel/" + this.channelId, {
        headers: {
          token: this.$store.state.auth.token
        },
        params: {
          'user_id': user_id
        }
        }
      ).then(() => {
        this.$store.commit("triggerRefresh");
        this.$toast.success(this.$t('toast.edit'));
      });
    },
    onClickAttachment() {
      this.$refs.file.click();
    },
    onActionAttachment() {
      axios.post(this.$store.getters.urlApi + "enrollment/channel/" + this.channelId + "/attachment", {
        type: this.modelAttachmentType,
        generatePassword: this.modelGeneratePassword,
        data: this.computedData,
        columns: this.modelColumns
      }, {
        headers: {
          token: this.$store.state.auth.token
        },
        }
      ).then(() => {
        this.$store.commit('triggerRefresh');
        this.$toast.success(this.$t('toast.create'));
      });
    },
    onClickBack() {
      this.$router.push({
        name: 'Channel',
        params: {
          channelId: this.channelId
        }
      });
    },
    onClickResetAttachment() {
      this.csv = [];
      this.$refs.file.value = "";
    },
    onClickExport() {
      let csvContent = "data:text/csv;charset=utf-8,";
      let header = this.modelColumns.join(',');
      csvContent += header + "\r\n";
      
      this.computedData.forEach(item => {
        let row = item.map(item => '"' + item + '"').join(",");
        csvContent += row + "\r\n";
      });
      
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", this.channelId + "_" + this.modelAttachmentType +  "_.csv");
      document.body.appendChild(link); // Required for FF

      link.click(); 
    },
    onClickExportStudentList() {
      let csvContent = "data:text/csv;charset=utf-8,";
      let header = ['username / uid', 'email', 'name', 'enrollment time'].join(',');
      csvContent += header + "\r\n";
      
      this.enrollments.forEach(item => {
        let row = [item.user.username, item.user.email, item.user.name, item.created_at].map(item => '"' + item + '"').join(",");
        csvContent += row + "\r\n";
      });
      
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", this.channelId + "_enrollments_.csv");
      document.body.appendChild(link); // Required for FF

      link.click(); 
    },
    
    // String
    stringUser(item, str) {
      if(item.hasOwnProperty('user')) {
        return item.user[str];
      } else {
        return "?";
      }
    },
    
    isEnrolled(user) {
      var result = false;
      if(this.enrollments.find(e => e.user_id === user._id)) {
        result = true;
      }
      return result;
    },
    
    toLower(text) {
      if(text)
        return text.toString().toLowerCase();
      else
        return "";
    },
    searchBy(items, term) {
      if (term) {
        return items.filter(item =>
        this.toLower(item.user.name).includes(this.toLower(term.trim())) ||
        this.toLower(item.user.email).includes(this.toLower(term.trim())) ||
        this.toLower(item.user.username).includes(this.toLower(term.trim()))
        )
      }

      return items
    },
    
    handleFiles() {
      if(typeof this.$refs.file.files[0] !== 'undefined') {
        // Check for the various File API support.
        if (window.FileReader) {
          // FileReader are supported.
          this.getAsText(this.$refs.file.files[0]);
        } else {
          alert('FileReader are not supported in this browser.');
        }
      }
    },

    getAsText(fileToRead) {
      var reader = new FileReader();
      // Read file into memory as UTF-8
      reader.readAsText(fileToRead);
      // Handle errors load
      reader.onload = this.loadHandler;
      reader.onerror = this.errorHandler;
    },

    loadHandler(event) {
      var csv = event.target.result;
      this.processData(csv);
    },

    processData(csv) {
      var allTextLines = csv.match(/[^\r\n]+/g); 
      var lines = [];
      for (var i=0; i<allTextLines.length; i++) {
      var data = this.processLine(allTextLines[i]);
      var tarr = [];
      for (var j=0; j<data.length; j++) {
        tarr.push(data[j]);
      }
      lines.push(tarr);
      }
      this.csv = lines;
    },
    
    processLine(text) {
       var re_valid =  /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/;
       var re_value =  /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
      if (!re_valid.test(text)) return null;
      var a = [];          
      text.replace(re_value,
        function(m0, m1, m2, m3) {
          if    (m1 !== undefined) a.push(m1.replace(/\\'/g, "'"));
          else if (m2 !== undefined) a.push(m2.replace(/\\"/g, '"'));
          else if (m3 !== undefined) a.push(m3);
          return ''; 
        });
      if (/,\s*$/.test(text)) a.push('');
      return a;
    },

    errorHandler(evt) {
      if(evt.target.error.name == "NotReadableError") {
        alert("Canno't read file !");
      }
    },
    stringLastActiveAt(user) {
      if(user.hasOwnProperty('last_active_at')) {
        var d = lastTimeAt(user.last_active_at.date);
        return d.value + this.$t(d.suffix);
      } else {
        return this.$t('admin.no_record');
      }
    },

  },
}
</script>
